// import React from "react";
// import { Container } from "react-bootstrap";
// import "./product.css";

// const products = [
//   {
//     id: 1,
//     title: "Reward Management System",
//     description:
//       "Cloud 10 empowers hotels to deliver personalized, meaningful guest experiences through intelligent loyalty program management. By seamlessly integrating with property management systems, mobile apps, and digital touchpoints, it enables hotels to recognize guest preferences and reward them in real time—creating lasting brand connections.",
//     image: require("./../assets/asset1.jpg"),
//   },
//   {
//     id: 2,
//     title: "Loyalty Management System",
//     description:
//       "Craft a multi-level rewards program tailored to your brand’s identity. Whether offering VIP check-ins, late departures, or exclusive lounge access, tier-based recognition gives guests compelling reasons to return",
//     image: require("./../assets/asset1.jpg"),
//   },
//   {
//     id: 3,
//     title: "Reputation Management System",
//     description:
//       "Cloud 10 is a comprehensive reputation management solution designed to protect, enhance, and amplify your hotel's public image. In an industry where every review matters and word of mouth travels faster than ever, Cloud 10 empowers hotels to stay ahead—by turning guest feedback into actionable insights and brand advocacy.",
//     image: require("./../assets/asset1.jpg"),
//   },
// ];

// const Product = () => {
//   return (
//     <Container className="py-5">
//       <h1 className="text-center mb-5">Our Products</h1>
//       {products.map((product, index) => (
//         <div
//           key={product.id}
//           className={`product-row ${index % 2 !== 0 ? "reverse" : ""}`}
//         >
//           <div className="product-image">
//             <img src={product.image} alt={product.title} />
//           </div>
//           <div className="product-text">
//             <h2>{product.title}</h2>
//             <p>{product.description}</p>
//             <button className="read-more-btn">Read More</button>
//           </div>
//         </div>
//       ))}
//     </Container>
//   );
// };

// export default Product;

import React from "react";
import { Container } from "react-bootstrap";
import { Link } from "react-router-dom";
import "./product.css";

const products = [
  {
    id: 1,
    title: "Reward Management System",
    description:
      "Cloud 10 empowers hotels to deliver personalized, meaningful guest experiences through intelligent loyalty program management. By seamlessly integrating with property management systems, mobile apps, and digital touchpoints, it enables hotels to recognize guest preferences and reward them in real time—creating lasting brand connections.",
    image: require("./../assets/reward.png"),
    link: "/product/reward",
  },
  {
    id: 2,
    title: "Loyalty Management System",
    description:
      "Craft a multi-level rewards program tailored to your brand’s identity. Whether offering VIP check-ins, late departures, or exclusive lounge access, tier-based recognition gives guests compelling reasons to return.",
    image: require("./../assets/loyalty.png"),
    link: "/product/loyalty",
  },
  {
    id: 3,
    title: "Reputation Management System",
    description:
      "Cloud 10 is a comprehensive reputation management solution designed to protect, enhance, and amplify your hotel's public image. In an industry where every review matters and word of mouth travels faster than ever, Cloud 10 empowers hotels to stay ahead—by turning guest feedback into actionable insights and brand advocacy.",
    image: require("./../assets/reputation.png"),
    link: "/product/reputation",
  },
  {
    id: 4,
    title: "Hotel Guest Experience",
    description:
      "Cloud 10 streamlines hotel stays by enabling guests to verify their data right after booking, ensuring fast pre-check-in and personalized service. Guests enjoy seamless digital key access and contactless automation throughout their stay. The journey wraps up with automated checkout, digital receipts, and loyalty integration, all backed by real-time data insights.",
    image: require("./../assets/product_image.jpg"),
    link: "/product/hotel-guest-experience",
  },
];

const Product = () => {
  return (
    <Container className="py-5">
      <h1 className="text-center mb-5">How we support You</h1>

      {products.map((product, index) => (
        <div
          key={product.id}
          className={`product-row ${index % 2 !== 0 ? "reverse" : ""}`}
        >
          <div className="product-image">
            <img src={product.image} alt={product.title} />
          </div>
          <div className="product-text">
            <h2>{product.title}</h2>
            <p>{product.description}</p>
            <Link to={product.link} className="read-more-btn">
              Read More
            </Link>
          </div>
        </div>
      ))}
    </Container>
  );
};

export default Product;
